/* globals Knitiv */

export default class UploadController {
	/* @ngInject */
	/**
	 * @param {import('angular').ILocationService} $location
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').IScope} $scope
	 */
	constructor($location, $rootScope, $scope) {
		this.$location = $location;
		this.$scope = $scope;

		this.options = {
			mail: true,
		};

		$scope.$on('$viewContentLoaded', () => {
			$rootScope.showSearch = false;
		});
	}

	cancel() {
		this.$location.url('/');
	}

	submit() {
		this.$location.url('/');
	}
}
